// extracted by extract-css-chunks-webpack-plugin
module.exports = {"inner":"dashboard-left__inner--19T8A","left":"dashboard-left__left--1LUMK","active":"dashboard-left__active--3y3-A"};